import { ROUTES } from "../components/shared/constant";
import { IRouteDetails } from "../common/App.interface";
import {
  Home,
  Dashboard,
  Apps,
  Account,
  InstancesParent,
  InstanceHistory,
  InstancesDetails,
  InstanceBackup,
  TenantsSettings,
  CreateTenant,
  LogsPage,
  UsersAccessPage,
  RoleManagementPage,
  ErrorPage,
  // GeneralSettingsPage, // Removed — theme toggle moved to profile menu
  EmailSettingsPage,
  AppPreferencesPage,
  FieldsPage,
  CreatePortalPage,
  AllPortalsPage,
  PortalsDashboardPage,
  PortalBoardView,
  PortalListView,
  PortalCalendarView,
  WorkItemDetailPage,
  CreateWorkItemPage,
  PortalSettingsPage,
  PortalSettingsAccessPage,
  ServiceDeskPage,
  RequestTypeDetailPage,
  WorkflowEditorPage,
  AgentGroupsPage,
  QueuesSettingsPage,
  PortalEmailSettingsPage,
  AssignmentMatrixPage,
  PortalQueueView,
  CustomFieldsPage,
  FormBuilderPage,
  ArchivedTicketsPage,
  BinPage,
  CustomReportsSettingsPage,
  FormFillPage,
  SLAPoliciesPage,
  RecurringTicketsPage,
  ScheduledReportsPage,
  BusinessHoursPage,
  AutomationsPage,
  AutomationRuleEditor,
  MacrosPage,
  KnowledgeBasePage,
  KbArticleEditorPage,
  CsatSettingsPage,
  NpsSettingsPage,
  IntegrationsPage,
  DataSyncPage,
  HubSpotConfigPage,
  SharePointConfigPage,
  InboxPage,
  ReportsPage,
  CreatedVsResolvedReport,
  SLAComplianceReport,
  AgentPerformanceReport,
  RequestTypeReport,
  ResolutionTimeReport,
  CsatReport,
  NpsReport,
  ReportBuilderPage,
  CustomReportPage,
  CustomerPortalSettingsPage,
  UserManualPage,
  ContactsPage,
  ContactDetailPage,
  OrganizationsPage,
  OrgDetailPage,
  AiPlaygroundPage,
  AiAgentSettingsPage,
  SkyAgentWorkspacePage,
  SkyAgentProjectsPage,
  SkyAgentArtifactsPage,
  SkyAgentSchedulesPage,
  SkyAgentSkillsPage,
  SkyAgentCustomizePage,
  SkyAgentConfigurationPage,
  SkyBrainRootPage,
  SkyBrainIndexPage,
  SkyBrainSettingsPage,
  SkyBrainSystemPromptPage,
  SkyBrainMemoryPage,
  SkyBrainSkillsPage,
  SkyBrainIntegrationsPage,
} from "./lazyComponents";

export interface CreateRoutesConfig {
  hideNewdashboard: boolean;
}

export function createAppRoutes(config: CreateRoutesConfig): IRouteDetails[] {
  const { hideNewdashboard } = config;

  return [
    {
      name: "OldDashboard",
      path: ROUTES.HOME,
      component: Home,
      isRealTimeDataOn: false,
      accessibilityConditions: [hideNewdashboard],
    },
    {
      name: "NewDashboard",
      path: ROUTES.HOME,
      component: Dashboard,
      isRealTimeDataOn: false,
      accessibilityConditions: [!hideNewdashboard],
    },
    {
      name: "Apps",
      path: ROUTES.APPS + ROUTES.QUERYPARAMS,
      component: Apps,
      isRealTimeDataOn: false,
    },
    // General Settings page removed — theme toggle moved to profile menu
    // {
    //   name: "GeneralSettings",
    //   path: ROUTES.GENERAL_SETTINGS + ROUTES.QUERYPARAMS,
    //   component: GeneralSettingsPage,
    //   isRealTimeDataOn: false,
    // },
    {
      name: "EmailSettings",
      path: ROUTES.EMAIL_SETTINGS + ROUTES.QUERYPARAMS,
      component: EmailSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      name: "AppPreferences",
      path: ROUTES.APP_PREFERENCES + ROUTES.QUERYPARAMS,
      component: AppPreferencesPage,
      isRealTimeDataOn: false,
    },
    {
      name: "Fields",
      path: ROUTES.FIELDS + ROUTES.QUERYPARAMS,
      component: FieldsPage,
      isRealTimeDataOn: false,
    },
    {
      name: "Account",
      isRealTimeDataOn: false,
      path: ROUTES.ACCOUNT + ROUTES.QUERYPARAMS,
      component: Account,
    },
    {
      path: ROUTES.ERRORPAGE + ROUTES.QUERYPARAMS,
      name: "ErrorPage",
      component: ErrorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCES + ROUTES.QUERYPARAMS,
      name: "InstancesParent",
      component: InstancesParent,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCEHISTORY + ROUTES.QUERYPARAMS,
      name: "InstanceHistory",
      component: InstanceHistory,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCEDETAILS + ROUTES.QUERYPARAMS,
      name: "InstancesDetails",
      component: InstancesDetails,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.VIEWINSTANCEBACKUP + ROUTES.QUERYPARAMS,
      name: "InstanceBackup",
      component: InstanceBackup,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.TENANTSETIINGS + ROUTES.QUERYPARAMS,
      name: "TenantsSettings",
      component: TenantsSettings,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CREATETENANT + ROUTES.QUERYPARAMS,
      name: "CreateTenant",
      component: CreateTenant,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.LOGS + ROUTES.QUERYPARAMS,
      name: "Logs",
      component: LogsPage,
      isRealTimeDataOn: false,
    },
    {
      // Access Management: still where roles are changed and people removed
      // or deleted (the Users & access drawer links here). The nav opens
      // Users & access.
      path: ROUTES.ROLES + ROUTES.QUERYPARAMS,
      name: "Roles",
      component: RoleManagementPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.USERS + ROUTES.QUERYPARAMS,
      name: "UsersAccess",
      component: UsersAccessPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.CUSTOMER_PORTAL_SETTINGS + ROUTES.QUERYPARAMS,
      name: "CustomerPortalSettings",
      component: CustomerPortalSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.USER_MANUAL + ROUTES.QUERYPARAMS,
      name: "UserManual",
      component: UserManualPage,
      isRealTimeDataOn: false,
    },
    // People — detail routes before list routes (more-specific first)
    {
      path: ROUTES.PEOPLE_CONTACT_DETAIL + ROUTES.QUERYPARAMS,
      name: "ContactDetail",
      component: ContactDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PEOPLE_CONTACTS + ROUTES.QUERYPARAMS,
      name: "Contacts",
      component: ContactsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PEOPLE_ORGANIZATION_DETAIL + ROUTES.QUERYPARAMS,
      name: "OrganizationDetail",
      component: OrgDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PEOPLE_ORGANIZATIONS + ROUTES.QUERYPARAMS,
      name: "Organizations",
      component: OrganizationsPage,
      isRealTimeDataOn: false,
    },
    // AI Playground (cross-portal view)
    {
      path: ROUTES.AI_PLAYGROUND + ROUTES.QUERYPARAMS,
      name: "AiPlayground",
      component: AiPlaygroundPage,
      isRealTimeDataOn: false,
    },
    // skyAgent + skyBrain. Every /skybrain/<page> is declared BEFORE Overview:
    // /skybrain also matches them as a prefix, so the specific paths have to be
    // matched first or the sub-page never renders.
    // The four workspace sub-pages are declared BEFORE /skyagent, which would
    // otherwise match each of them as a prefix and render the chat instead.
    {
      path: ROUTES.SKYAGENT_PROJECTS + ROUTES.QUERYPARAMS,
      name: "SkyAgentProjects",
      component: SkyAgentProjectsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYAGENT_ARTIFACTS + ROUTES.QUERYPARAMS,
      name: "SkyAgentArtifacts",
      component: SkyAgentArtifactsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYAGENT_SCHEDULES + ROUTES.QUERYPARAMS,
      name: "SkyAgentSchedules",
      component: SkyAgentSchedulesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYAGENT_SKILLS + ROUTES.QUERYPARAMS,
      name: "SkyAgentSkills",
      component: SkyAgentSkillsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYAGENT_CONFIGURATION + ROUTES.QUERYPARAMS,
      name: "SkyAgentConfiguration",
      component: SkyAgentConfigurationPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYAGENT_CUSTOMIZE + ROUTES.QUERYPARAMS,
      name: "SkyAgentCustomize",
      component: SkyAgentCustomizePage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYAGENT + ROUTES.QUERYPARAMS,
      name: "SkyAgentWorkspace",
      component: SkyAgentWorkspacePage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN_INDEX + ROUTES.QUERYPARAMS,
      name: "SkyBrainIndex",
      component: SkyBrainIndexPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN_SETTINGS + ROUTES.QUERYPARAMS,
      name: "SkyBrainSettings",
      component: SkyBrainSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN_SYSTEM_PROMPT + ROUTES.QUERYPARAMS,
      name: "SkyBrainSystemPrompt",
      component: SkyBrainSystemPromptPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN_MEMORY + ROUTES.QUERYPARAMS,
      name: "SkyBrainMemory",
      component: SkyBrainMemoryPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN_SKILLS + ROUTES.QUERYPARAMS,
      name: "SkyBrainSkills",
      component: SkyBrainSkillsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN_INTEGRATIONS + ROUTES.QUERYPARAMS,
      name: "SkyBrainIntegrations",
      component: SkyBrainIntegrationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.SKYBRAIN + ROUTES.QUERYPARAMS,
      name: "SkyBrainRoot",
      component: SkyBrainRootPage,
      isRealTimeDataOn: false,
    },
    // Unified Inbox (cross-portal view — replaces AllTickets + YourWork)
    {
      path: ROUTES.INBOX + ROUTES.QUERYPARAMS,
      name: "Inbox",
      component: InboxPage,
      isRealTimeDataOn: false,
    },
    // Tickets (legacy — kept for backward compat, now shows InboxPage)
    {
      path: ROUTES.TICKETS + ROUTES.QUERYPARAMS,
      name: "AllTickets",
      component: InboxPage,
      isRealTimeDataOn: false,
    },
    // Portals (project management)
    {
      path: ROUTES.PORTALS_CREATE + ROUTES.QUERYPARAMS,
      name: "CreatePortal",
      component: CreatePortalPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTALS + ROUTES.QUERYPARAMS,
      name: "AllPortals",
      component: AllPortalsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTALS_YOUR_WORK + ROUTES.QUERYPARAMS,
      name: "YourWork",
      component: Dashboard,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTALS_DASHBOARD + ROUTES.QUERYPARAMS,
      name: "PortalsDashboard",
      component: PortalsDashboardPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_ITEM_NEW + ROUTES.QUERYPARAMS,
      name: "CreateWorkItem",
      component: CreateWorkItemPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_ITEM_DETAIL + ROUTES.QUERYPARAMS,
      name: "WorkItemDetail",
      component: WorkItemDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_BOARD + ROUTES.QUERYPARAMS,
      name: "PortalBoard",
      component: PortalBoardView,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_LIST + ROUTES.QUERYPARAMS,
      name: "PortalList",
      component: PortalListView,
      isRealTimeDataOn: false,
    },

    {
      path: ROUTES.PORTAL_CALENDAR + ROUTES.QUERYPARAMS,
      name: "PortalCalendar",
      component: PortalCalendarView,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_REQUEST_TYPE_EDIT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsRequestTypeEdit",
      component: RequestTypeDetailPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_SERVICE_DESK + ROUTES.QUERYPARAMS,
      name: "PortalSettingsServiceDesk",
      component: ServiceDeskPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_AGENT_GROUPS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsAgentGroups",
      component: AgentGroupsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_QUEUES + ROUTES.QUERYPARAMS,
      name: "PortalSettingsQueues",
      component: QueuesSettingsPage,
      isRealTimeDataOn: false,
    },

    {
      path: ROUTES.PORTAL_SETTINGS_ACCESS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsAccess",
      component: PortalSettingsAccessPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_WORKFLOW + ROUTES.QUERYPARAMS,
      name: "PortalSettingsWorkflow",
      component: WorkflowEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_EMAIL + ROUTES.QUERYPARAMS,
      name: "PortalSettingsEmail",
      component: PortalEmailSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_ASSIGNMENT_MATRIX + ROUTES.QUERYPARAMS,
      name: "PortalSettingsAssignmentMatrix",
      component: AssignmentMatrixPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_CUSTOM_FIELDS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsCustomFields",
      component: CustomFieldsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_FORMS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsForms",
      component: FormBuilderPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_ARCHIVED + ROUTES.QUERYPARAMS,
      name: "PortalSettingsArchived",
      component: ArchivedTicketsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_BIN + ROUTES.QUERYPARAMS,
      name: "PortalSettingsBin",
      component: BinPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_REPORTS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsReports",
      component: CustomReportsSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.FORM_FILL + ROUTES.QUERYPARAMS,
      name: "FormFill",
      component: FormFillPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_SLA + ROUTES.QUERYPARAMS,
      name: "PortalSettingsSLA",
      component: SLAPoliciesPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_RECURRING_TICKETS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsRecurringTickets",
      component: RecurringTicketsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_SCHEDULED_REPORTS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsScheduledReports",
      component: ScheduledReportsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_BUSINESS_HOURS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsBusinessHours",
      component: BusinessHoursPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_AUTOMATION_EDIT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsAutomationEdit",
      component: AutomationRuleEditor,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_AUTOMATIONS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsAutomations",
      component: AutomationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_MACROS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsMacros",
      component: MacrosPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_KB_ARTICLE_EDIT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsKbArticleEdit",
      component: KbArticleEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_KB_ARTICLE_NEW + ROUTES.QUERYPARAMS,
      name: "PortalSettingsKbArticleNew",
      component: KbArticleEditorPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_KNOWLEDGE_BASE + ROUTES.QUERYPARAMS,
      name: "PortalSettingsKnowledgeBase",
      component: KnowledgeBasePage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_CSAT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsCsat",
      component: CsatSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_NPS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsNps",
      component: NpsSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_INTEGRATIONS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsIntegrations",
      component: IntegrationsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_DATA_SYNC + ROUTES.QUERYPARAMS,
      name: "PortalSettingsDataSync",
      component: DataSyncPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_HUBSPOT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsHubSpot",
      component: HubSpotConfigPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_SHAREPOINT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsSharePoint",
      component: SharePointConfigPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_AI_AGENT + ROUTES.QUERYPARAMS,
      name: "PortalSettingsAiAgent",
      component: AiAgentSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_CREATED_VS_RESOLVED + ROUTES.QUERYPARAMS,
      name: "PortalReportCreatedVsResolved",
      component: CreatedVsResolvedReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_SLA_COMPLIANCE + ROUTES.QUERYPARAMS,
      name: "PortalReportSLACompliance",
      component: SLAComplianceReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_AGENT_PERFORMANCE + ROUTES.QUERYPARAMS,
      name: "PortalReportAgentPerformance",
      component: AgentPerformanceReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_REQUEST_TYPES + ROUTES.QUERYPARAMS,
      name: "PortalReportRequestTypes",
      component: RequestTypeReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_RESOLUTION_TIME + ROUTES.QUERYPARAMS,
      name: "PortalReportResolutionTime",
      component: ResolutionTimeReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_CSAT + ROUTES.QUERYPARAMS,
      name: "PortalReportCsat",
      component: CsatReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_NPS + ROUTES.QUERYPARAMS,
      name: "PortalReportNps",
      component: NpsReport,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_CUSTOM_REPORT + ROUTES.QUERYPARAMS,
      name: "PortalCustomReport",
      component: CustomReportPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_BUILDER_EDIT + ROUTES.QUERYPARAMS,
      name: "PortalReportBuilderEdit",
      component: ReportBuilderPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORT_BUILDER + ROUTES.QUERYPARAMS,
      name: "PortalReportBuilder",
      component: ReportBuilderPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_REPORTS + ROUTES.QUERYPARAMS,
      name: "PortalReports",
      component: ReportsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS_DETAILS + ROUTES.QUERYPARAMS,
      name: "PortalSettingsDetails",
      component: PortalSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_SETTINGS + ROUTES.QUERYPARAMS,
      name: "PortalSettings",
      component: PortalSettingsPage,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_QUEUE_VIEW + ROUTES.QUERYPARAMS,
      name: "PortalQueueView",
      component: PortalQueueView,
      isRealTimeDataOn: false,
    },
    {
      path: ROUTES.PORTAL_QUEUES + ROUTES.QUERYPARAMS,
      name: "PortalQueues",
      component: PortalQueueView,
      isRealTimeDataOn: false,
    },
  ];
}
